import PropTypes from "prop-types";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import { Stack } from "@mui/material";

import { CenteredLoading } from "@/features/ui";

import {
  DEFAULT_VALUES,
  VALIDATION_SCHEMA,
} from "../outlet-payment-method-form-constants";
import { PaymentMethodMappingSection } from "../payment-method-mapping-section";

export const OutletPaymentMethodForm = ({
  defaultValues,
  onSubmit,
  renderActionButton,
  outletId,
  disabled = false,
  isLoading = false,
}) => {
  const methods = useForm({
    defaultValues: DEFAULT_VALUES,
    resolver: yupResolver(VALIDATION_SCHEMA),
  });
  const { handleSubmit, reset, formState } = methods;

  useEffect(() => {
    if (defaultValues) {
      reset({ ...DEFAULT_VALUES, ...defaultValues });
    }
  }, [defaultValues, reset]);

  if (isLoading) {
    return <CenteredLoading />;
  }

  return (
    <FormProvider {...methods}>
      <Stack
        component="form"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        spacing={3}
      >
        <PaymentMethodMappingSection outletId={outletId} disabled={disabled} />
        {renderActionButton?.({ isSubmitting: formState.isSubmitting })}
      </Stack>
    </FormProvider>
  );
};

OutletPaymentMethodForm.propTypes = {
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  renderActionButton: PropTypes.func,
  outletId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};
